// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { KindPrimarySkill } from "../schema";

export function serialize_KindPrimarySkill_internal(value: KindPrimarySkill): unknown {
  return ((value: "primary-skill"): unknown => {
    return value;
  })(value);
}
export function serialize_KindPrimarySkill(obj: KindPrimarySkill): string {
  return renderJsonWithNumbersAsBigint(serialize_KindPrimarySkill_internal(obj));
}
export function deserialize_KindPrimarySkill_internal(value: unknown): ParserResult<KindPrimarySkill> {
  return ((value: unknown): ParserResult<"primary-skill"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/KindPrimarySkill]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "primary-skill":
        return { success: true, value: "primary-skill" };
      default:
        return { success: false, reason: `[#/components/schemas/KindPrimarySkill]: '${value}' expected to be enum, one of 'primary-skill'.` };
    }
  })(value);
}
export function deserialize_KindPrimarySkill(str: string): ParserResult<KindPrimarySkill> {
  return deserialize_KindPrimarySkill_internal(parseJsonWithNumbersAsBigint(str));
}
